import { MapButton } from '@/components/controls';
import { ZoomOutMap as ZoomOutMapIcon } from '@mui/icons-material';
import { useMap } from 'react-map-gl/maplibre';

export function FitMapButton({ boundingBox }) {
  const map = useMap();

  function handleClick() {
    if (map.current) {
      map.current.fitBounds(boundingBox, {
        maxZoom: 16,
        padding: 32,
        duration: 1000,
      });
    }
  }

  return (
    <MapButton title="Fit map" onClick={handleClick} disabled={!boundingBox}>
      <ZoomOutMapIcon />
    </MapButton>
  );
}
